export interface ISsPlayerPayments {
  action: 'deposit' | 'cashout'; // "deposit"
  amount_cents: number; // 2000
  created_at: string; // "2021-05-18T14:27:11.709Z"
  currency: string; // "EUR"
  finished_at: string; // "2021-05-18T14:27:11.708Z"
  id: number; // 1095237
  payment_system: string; // "Кредитная карта"
  recallable: boolean; // false
  success: boolean; // true
  system_name: string; // "devcode"
  state: string;
}

export enum ESsPlayerPaymentStatus {
  IN_PROGRESS = 'progress',
  SUCCESS = 'success',
  REJECTED = 'reject',
}
